import * as React from 'react';
import { snap } from 'storybook-snapper';
import SettingsChangedEvent from './fakeTPAChange.json';
import {
  colorNameToPosition,
  mainPalette,
  mainPaletteInverted,
} from './palettes';
import { AsyncVisualTestWrapper } from './visualTestWrapper';
import type { TPAComponentsConfig } from '../components/TPAComponentsConfig';

function changePalette(palette) {
  return new Promise((res) => {
    const obj = { ...SettingsChangedEvent };

    // @ts-expect-error
    window.Wix.addEventListener(SettingsChangedEvent.eventType, () => {
      requestAnimationFrame(res);
    });

    obj.params.siteColors.forEach((color) => {
      const position = colorNameToPosition(color.reference);

      if (position) {
        color.value = palette[position.col][position.row];
      }
    });

    window.postMessage(JSON.stringify(obj), '*');
  });
}

export const setDarkPalette = () => {
  return changePalette(mainPaletteInverted);
};

export const resetPalette = async () => {
  return changePalette(mainPalette);
};

export function snapWithDarkTheme(
  title = 'with dark theme',
  renderFn,
  context: TPAComponentsConfig = {}
) {
  const { mobile, rtl } = context;
  return snap(
    title,
    (done) => (
      <AsyncVisualTestWrapper
        withDarkTheme
        onDoneCallback={done}
        isMobile={mobile}
        isRtl={rtl}
      >
        {renderFn()}
      </AsyncVisualTestWrapper>
    ),
    {
      runAfter: resetPalette,
    }
  );
}

export const clickElement = (dataHook) => {
  const node = document.body;
  const dataHookSelector = `[data-hook*=${dataHook}]`;
  const element = node.querySelector(dataHookSelector) as HTMLElement;
  element.click();
};

export const focusElement = (dataHook) => {
  const node = document.body;
  const dataHookSelector = `[data-hook*=${dataHook}]`;
  const element = node.querySelector(dataHookSelector) as HTMLElement;
  element.focus();
};
